export interface UseCaseInvocation {
    name: string,
    version: number
}
/** helper function to create UseCaseInvocations */
export function useCaseInvocationFromBackendObject(uc: any): UseCaseInvocation {
    if (!uc['name']) uc['name'] = "???";
    if (!uc['version']) uc['version'] = 1;
    return uc as UseCaseInvocation;
}
